/**
 * @file 确认弹窗
 * @author wangzian@baidu.com
 * */

import {Component} from 'san';
import './index.scss';
import HugModal from '@components/hug-modal';

export default class HugConfirm extends Component {
    static template = `
        <components-hug-modal
            value="{{value}}">
            <div class="c-hug-confirm">
                <div class="content">
                    <slot></slot>
                </div>
                <div class="footer" s-if="{{footerVisible}}">
                    <div class="footer-btn" on-click="cancel">{{cancelText}}</div>
                    <div class="footer-btn confirm" on-click="confirm">{{confirmText}}</div>
                </div>
            </div>
        </components-hug-modal>
    `;

    static components = {
        'components-hug-modal': HugModal
    };

    initData() {
        return {
            footerVisible: true,
            cancelText: '取消',
            confirmText: '确定',
            value: false
        };
    }

    cancel() {
        this.fire('cancel');
        this.data.set('value', false);
    }

    confirm() {
        this.fire('confirm');
        this.data.set('value', false);
    }
}
